import { _rails } from '../../modules/constants';
import  {stringify}  from 'querystring';
export default class payments_index extends EventedClass {
    constructor() {
        super();
        this.elem = {
            card_form: null,
            datos: null,
            error_code: null,
            errors: null,
            order_id: "",
            oper_id: null,
            btn_pay: null,
            cart_tickets: null
        }
        // CALLING INSTALL
        this.initialize();
    }

    initialize() {
        console.log("payments controller index action")
        this.elem.btn_pay = $('#btn-pay')
        this.elem.card_form = $('#card-form')
        this.elem.datos = $('[name="datos"]')
        this.elem.error_code = this.elem.datos.children('#errorCode')
        this.elem.oper_id    = this.elem.datos.children('#token')
        this.elem.cart_tickets = $('.cart-tickets')
        this.elem.errors = $('.redsys-errors')
        this.merchant = {
            fuc: this.elem.card_form.data('f'),
            terminal: this.elem.card_form.data('t')
        }
        this.cartId   = this.elem.card_form.data('id')
        this._installEvents()
    }

    _installEvents() {
        this.elem.btn_pay.on("click", this._onClickBtnPay.bind(this))
    }

    _onClickBtnPay(e) {
        const self = this
        this._pedido()
        const payload = stringify({
            cart_id: self.cartId,
            order_id: self.elem.order_id
        })

        App.utils.loaderON()
        Rails.ajax({
            url: _rails.url.payment_form_abonats, type: "POST", data: payload,
            success: (data) => {
                if (typeof data === "object"){
                    const $form = $('form#frm_payment')
                    $form.children("[name='Ds_MerchantParameters']").val(data.Ds_MerchantParameters)
                    $form.children("[name='Ds_Signature']").val(data.Ds_Signature)
                    $form[0].submit()
                }else{
                    console.error('Invalid data payment', data)
                }
            },
            error: (e) => {
                console.error("Error cart",e)
                App.utils.notify.error(App.messages.global.redsys.ca.error, "Error de pagament", {
                    timeOut: 5000,
                    positionClass: App.utils.isMobile()? "toast-top-full-width":"toast-bottom-full-width",
                    preventDuplicates: true
                })
            },
            complete: () => {
                App.utils.loaderOFF()
            }
        })
    }
    _pedido() {
        let tmp = (1000 + Math.floor(Math.random() * 9000)) + this.cartId;
        this.elem.order_id = tmp.toString().substr(0,12)
        console.log(this.elem.order_id)
        return this.elem.order_id
    }
}